module.exports = __webpack_public_path__ + "img/icon_page3_phone.0162ba38.png";